import { useInfiniteQuery } from '@tanstack/react-query'
import { httpGetLocations } from '@/features/luxe-submissions/http/luxe-submissions.http'

export const LOCATIONS_QUERY_KEY = 'locations'

export const useGetLocations = (search?: string) => {
	const query = useInfiniteQuery({
		queryKey: [LOCATIONS_QUERY_KEY, search],
		queryFn: ({ pageParam }) =>
			httpGetLocations({ search, page: pageParam }),
		initialPageParam: 1,
		getNextPageParam: ({ meta }) =>
			meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null
	})

	return {
		...query,
		// Flatten pages into a single array of locations
		remappedData: query.data?.pages.flatMap((page) => page.data) || []
	}
}
